module.exports = __webpack_public_path__ + "img/Schlauchtruppmann.520b21d5.svg";